// inoneyear-specific UI strings, merged on top of holybible locale files.
const ZH: Record<string, string> = {
  "app.title": "读经一年一遍",
  "app.subtitle": "每天读一点，一年读完整本圣经",
  "reading.noPlan": "今天没有安排读经，可以休息或补前面的进度",
  "reading.futureDay": "这一天还没到，先读当天的经文吧",
  "reading.prevDay": "上一日",
  "reading.nextDay": "下一日",
  "reading.today": "今天",
  "reading.checkin": "打卡",
  "reading.checkinRead": "已阅",
  "reading.checkinDone": "今日已打卡 ✓",
  "reading.checkinCount": "已打卡 {count} 天",
  "reading.checkinPeople": "今日已有 {count} 人打卡",
  "reading.checkinHistory": "打卡历史",
  "myCheckins.title": "我的打卡",
  "myCheckins.sharesTab": "我的分享",
  "myCheckins.catchUp": "补打卡",
  "myCheckins.loadMore": "加载更多",
  "reading.shareLabel": "读后分享",
  "reading.sharePlaceholder": "写下今天的读后感动，与大家交流…",
  "reading.shareSubmit": "发布分享",
  "reading.replyQuote": "引用回复",
  "reading.quoteOf": "引用 {author}",
  "reading.cancelQuote": "取消引用",
  "reading.shares": "今日分享",
  "reading.noShares": "还没有分享，快来第一个留言吧",
  "reading.shareWithCheckin": "打卡并分享",
  "verse.copy": "复制经文",
  "verse.highlight": "重点标注",
  "verse.unhighlight": "取消重点",
  "verse.image": "美图生成",
  "verse.copied": "已复制",
  "auth.login": "登录",
  "auth.logout": "退出登录",
  "auth.email": "邮箱",
  "auth.sendCode": "发送验证码",
  "auth.verifyAndLogin": "验证并登录",
  "auth.code": "6 位验证码",
  "auth.codeSent": "验证码已发送，请查收邮件",
  "auth.validEmail": "请输入有效邮箱",
  "auth.codeRequired": "请输入验证码",
  "auth.loginSuccess": "登录成功",
  "auth.tooManyRequests": "请求过于频繁，请稍后再试",
  "auth.sendCodeFailed": "验证码发送失败，请稍后再试",
  "auth.networkError": "网络异常，请检查网络后重试",
  "auth.invalidCode": "验证码错误或已过期",
  "auth.verifyFailed": "登录失败，请稍后再试",
  "auth.modalTitle": "登录读经一年一遍",
  "auth.modalSubtitle": "输入邮箱，通过验证码登录，无需密码",
  "auth.emailPlaceholder": "请输入邮箱",
  "auth.codeSentTo": "验证码已发送至 {email}",
  "auth.changeEmail": "更换邮箱",
  "auth.resend": "重新发送",
  "auth.resendIn": "重新发送（{s}s）",
  "auth.benefits": "登录后可打卡、发布读后分享",
  "common.loading": "加载中…",
  "common.error": "出错了，请稍后再试",
  "common.retry": "重试",
  "reading.dayOfPlan": "第 {n} 天",
  "settings.fontSize": "字号",
  "settings.theme": "主题",
  "settings.version": "圣经版本",
  "settings.versionPicker": "选择版本",
  "settings.versionPickerCount": "（{n}/5）",
  "settings.readAloud": "语音播报",
  "settings.stopReading": "停止播报",
  "settings.voiceChecking": "正在检测语音支持，请稍候…",
  "settings.voiceNotSupported": "当前浏览器没有可用的 {lang} 语音，请更换浏览器或切换语言后再试",
  "settings.voicePlaybackFailed": "语音播报失败（{lang}），当前浏览器可能不支持该语言，请更换浏览器或切换语言",
  "theme.light": "明亮",
  "theme.dark": "夜间",
  "theme.classic": "典雅",
  "reading.topic": "主题",
  "reading.topicColon": "：",
  "reading.outline": "纲目",
  "reading.footnote": "注解",
  "reading.noteMark": "注",
  "reading.mergedNote": "（{a}、{b}节合并。）",
  "verse.flag.upper": "上",
  "verse.flag.middle": "中",
  "verse.flag.lower": "下",
  "annotation.noVerseFound": "未找到相关经文",
  "annotation.noFootnoteFound": "未找到相关注解",
  "annotation.back": "返回上一级",
};

const TW: Record<string, string> = {
  "app.title": "讀經一年一遍",
  "app.subtitle": "每天讀一點，一年讀完整本聖經",
  "reading.noPlan": "今天沒有安排讀經，可以休息或補前面的進度",
  "reading.futureDay": "這一天還沒到，先讀當天的經文吧",
  "reading.prevDay": "上一日",
  "reading.nextDay": "下一日",
  "reading.today": "今天",
  "reading.checkin": "打卡",
  "reading.checkinRead": "已閱",
  "reading.checkinDone": "今日已打卡 ✓",
  "reading.checkinCount": "已打卡 {count} 天",
  "reading.checkinPeople": "今日已有 {count} 人打卡",
  "reading.checkinHistory": "打卡歷史",
  "myCheckins.title": "我的打卡",
  "myCheckins.sharesTab": "我的分享",
  "myCheckins.catchUp": "補打卡",
  "myCheckins.loadMore": "載入更多",
  "reading.shareLabel": "讀後分享",
  "reading.sharePlaceholder": "寫下今天的讀後感動，與大家交流…",
  "reading.shareSubmit": "發佈分享",
  "reading.replyQuote": "引用回覆",
  "reading.quoteOf": "引用 {author}",
  "reading.cancelQuote": "取消引用",
  "reading.shares": "今日分享",
  "reading.noShares": "還沒有分享，快來第一個留言吧",
  "reading.shareWithCheckin": "打卡並分享",
  "verse.copy": "複製經文",
  "verse.highlight": "重點標註",
  "verse.unhighlight": "取消重點",
  "verse.image": "美圖生成",
  "verse.copied": "已複製",
  "auth.login": "登入",
  "auth.logout": "登出",
  "auth.email": "信箱",
  "auth.sendCode": "發送驗證碼",
  "auth.verifyAndLogin": "驗證並登入",
  "auth.code": "6 位驗證碼",
  "auth.codeSent": "驗證碼已發送，請查收郵件",
  "auth.validEmail": "請輸入有效信箱",
  "auth.codeRequired": "請輸入驗證碼",
  "auth.loginSuccess": "登入成功",
  "auth.tooManyRequests": "請求過於頻繁，請稍後再試",
  "auth.sendCodeFailed": "驗證碼發送失敗，請稍後再試",
  "auth.networkError": "網路異常，請檢查網路後重試",
  "auth.invalidCode": "驗證碼錯誤或已過期",
  "auth.verifyFailed": "登入失敗，請稍後再試",
  "auth.modalTitle": "登入讀經一年一遍",
  "auth.modalSubtitle": "輸入信箱，透過驗證碼登入，無需密碼",
  "auth.emailPlaceholder": "請輸入信箱",
  "auth.codeSentTo": "驗證碼已寄送至 {email}",
  "auth.changeEmail": "更換信箱",
  "auth.resend": "重新發送",
  "auth.resendIn": "重新發送（{s}s）",
  "auth.benefits": "登入後可打卡、發佈讀後分享",
  "common.loading": "載入中…",
  "common.error": "出錯了，請稍後再試",
  "common.retry": "重試",
  "reading.dayOfPlan": "第 {n} 天",
  "settings.fontSize": "字號",
  "settings.theme": "主題",
  "settings.version": "聖經版本",
  "settings.versionPicker": "選擇版本",
  "settings.versionPickerCount": "（{n}/5）",
  "settings.readAloud": "語音播報",
  "settings.stopReading": "停止播報",
  "settings.voiceChecking": "正在偵測語音支援，請稍候…",
  "settings.voiceNotSupported": "目前瀏覽器沒有可用的 {lang} 語音，請更換瀏覽器或切換語言後再試",
  "settings.voicePlaybackFailed": "語音播報失敗（{lang}），目前瀏覽器可能不支援該語言，請更換瀏覽器或切換語言",
  "theme.light": "明亮",
  "theme.dark": "夜間",
  "theme.classic": "典雅",
  "reading.topic": "主題",
  "reading.topicColon": "：",
  "reading.outline": "綱目",
  "reading.footnote": "註解",
  "reading.noteMark": "註",
  "reading.mergedNote": "（{a}、{b}節合併。）",
  "verse.flag.upper": "上",
  "verse.flag.middle": "中",
  "verse.flag.lower": "下",
  "annotation.noVerseFound": "未找到相關經文",
  "annotation.noFootnoteFound": "未找到相關註解",
  "annotation.back": "返回上一級",
};

const EN: Record<string, string> = {
  "app.title": "Read the Bible in One Year",
  "app.subtitle": "Read a little every day, finish the whole Bible in one year",
  "reading.noPlan": "No reading assigned today. Rest or catch up!",
  "reading.futureDay": "This day hasn't arrived yet. Read today's passage first.",
  "reading.prevDay": "Previous day",
  "reading.nextDay": "Next day",
  "reading.today": "Today",
  "reading.checkin": "Check in",
  "reading.checkinRead": "Read",
  "reading.checkinDone": "Checked in today ✓",
  "reading.checkinCount": "{count} days checked in",
  "reading.checkinPeople": "{count} people checked in today",
  "reading.checkinHistory": "Check-in history",
  "myCheckins.title": "My Check-ins",
  "myCheckins.sharesTab": "My Shares",
  "myCheckins.catchUp": "Catch up",
  "myCheckins.loadMore": "Load more",
  "reading.shareLabel": "Share",
  "reading.sharePlaceholder": "Share what you read today…",
  "reading.shareSubmit": "Post",
  "reading.replyQuote": "Quote & reply",
  "reading.quoteOf": "Quoting {author}",
  "reading.cancelQuote": "Cancel",
  "reading.shares": "Today's shares",
  "reading.noShares": "No shares yet — be the first!",
  "reading.shareWithCheckin": "Check in & share",
  "verse.copy": "Copy verse",
  "verse.highlight": "Highlight",
  "verse.unhighlight": "Unhighlight",
  "verse.image": "Verse image",
  "verse.copied": "Copied",
  "auth.login": "Sign in",
  "auth.logout": "Sign out",
  "auth.email": "Email",
  "auth.sendCode": "Send code",
  "auth.verifyAndLogin": "Verify & sign in",
  "auth.code": "6-digit code",
  "auth.codeSent": "Code sent! Check your email.",
  "auth.validEmail": "Valid email required",
  "auth.codeRequired": "Code required",
  "auth.loginSuccess": "Signed in",
  "auth.tooManyRequests": "Too many requests — try again later",
  "auth.sendCodeFailed": "Failed to send code. Try again later.",
  "auth.networkError": "Network error. Check your connection.",
  "auth.invalidCode": "Invalid or expired code",
  "auth.verifyFailed": "Sign-in failed. Try again later.",
  "auth.modalTitle": "Sign in to Read the Bible in One Year",
  "auth.modalSubtitle": "Enter your email and sign in with a code — no password needed.",
  "auth.emailPlaceholder": "Enter your email",
  "auth.codeSentTo": "Code sent to {email}",
  "auth.changeEmail": "Change email",
  "auth.resend": "Resend",
  "auth.resendIn": "Resend ({s}s)",
  "auth.benefits": "Sign in to check in and share your reading.",
  "common.loading": "Loading…",
  "common.error": "Something went wrong",
  "common.retry": "Retry",
  "reading.dayOfPlan": "Day {n}",
  "settings.fontSize": "Font size",
  "settings.theme": "Theme",
  "settings.version": "Bible version",
  "settings.versionPicker": "Select versions",
  "settings.versionPickerCount": " ({n}/5)",
  "settings.readAloud": "Read aloud",
  "settings.stopReading": "Stop",
  "settings.voiceChecking": "Checking voice support…",
  "settings.voiceNotSupported": "No {lang} voice available in this browser. Try another browser or switch language.",
  "settings.voicePlaybackFailed": "Read-aloud failed ({lang}). Your browser may not support this language. Try another browser or switch language.",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.classic": "Classic",
  "reading.topic": "Topic",
  "reading.topicColon": ": ",
  "reading.outline": "Outline",
  "reading.footnote": "Note",
  "reading.noteMark": "Note",
  "reading.mergedNote": "({a}, {b} merged.)",
  "verse.flag.upper": "①",
  "verse.flag.middle": "②",
  "verse.flag.lower": "③",
  "annotation.noVerseFound": "Verse not found",
  "annotation.noFootnoteFound": "Annotation not found",
  "annotation.back": "Back",
};

export const extraMessages = (locale: string): Record<string, string> => {
  const l = (locale || "").toLowerCase();
  if (l === "zh-tw" || l === "zh-hk" || l === "zh-mo" || l === "zh-hant") return TW;
  if (l.startsWith("zh")) return ZH;
  return EN;
};
